import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { FooterMenu } from '../../domain/models/footer-menu.model';
import { OpcaoMenu } from '../../domain/models/opcao-menu.model';
import { OpcaoMenuComIcone } from '../../domain/models/opcao-menu-com-icone.model';

@Component({
  selector: 'app-segov-sigepo-footer',
  standalone: true,
  imports: [],
  templateUrl: './segov-sigepo-footer.component.html',
  styleUrl: './segov-sigepo-footer.component.css'
})
export class SegovSigepoFooterComponent {
  constructor(private readonly router: Router){}

  @Input() socialMedia!: FooterMenu[];
  @Input() menuPrincipal!: OpcaoMenu[];
  @Input() linksUteis!: OpcaoMenuComIcone[];
  @Input() telefonesTexto!: string[];
  @Input() emailTexto!: string;
  @Input() versaoRelease = '0.0.1';
  @Input() exibirVersaoRelease = false;

  public buttonAction(opcao: OpcaoMenu){
    if(opcao.customAction) opcao.customAction();
    else if(opcao.rotaExterna) window.open(opcao.rotaExterna, "_blank");
    else if(opcao.rota) this.router.navigate([opcao.rota]);
  }
}
